// import strategyImg from '../../images/services/strategy.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const BusinessStrategyAndTransformation = () => {
  const serviceData = {
    title: "Business Strategy & Transformation",
    heading: "Business Strategy & Transformation",
    image: subTopicImages["Business Strategy & Transformation"],
    intro: "",
    description: [
      "We work with leadership teams to refine strategy, review business models and align organisational design, capital allocation and decision-making frameworks — ensuring growth plans are financially sound, measurable and execution-ready.",
    ],
    services: [],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default BusinessStrategyAndTransformation;
